import { Injectable } from '@angular/core';
import { apiEndpoints } from '../../core/constants/api-strings';
import { EventDetailsResponseModel } from './home.model';
import { BaseResponse } from '../../shared/models/base-response.model';
import { BaseHttpService, HttpResult } from '../../core/services/base-http.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeApiService extends BaseHttpService {

  constructor() {
    super();
  }

  // Base URL for master-related APIs
  private readonly masterBaseUrl = environment.master_base_url;

  private eventcode = this.storage.getEventCode() || "KISAN25";

  /**
   * @description Fetch event details
   */
  getEventDetails(): Observable<HttpResult<BaseResponse<EventDetailsResponseModel>>> {
    let serviceName = `${this.masterBaseUrl +
      apiEndpoints.farmerDigitalCatalog.events +
      this.eventcode
      }`;

    return this.get<BaseResponse<EventDetailsResponseModel>>(serviceName, {}, false);
  }

}
